export default __webpack_public_path__ + "static/media/007.d997f9da.jpg";